import {
  CompanyLogosResponseDataInner,
  getCompanyLogos,
} from "@rentablo/api/quotes";
import { Image } from "@providers";
import { isCryptoProvider, markMissing } from "./helpers";

export const pickImageUrl = (logo: CompanyLogosResponseDataInner) =>
  logo.attributes.url_svg ||
  logo.attributes.url_medium ||
  logo.attributes.url_small ||
  logo.attributes.url_large;

export const fetchFromApi = async (
  quoteProvider: string,
  ids: string[]
): Promise<Record<string, Image>> => {
  try {
    const isCrypto = isCryptoProvider(quoteProvider);
    const response = await getCompanyLogos(undefined, {
      quoteProvider,
      filterIsin: isCrypto ? undefined : ids.join(","),
      filterSymbol: isCrypto ? ids.join(",") : undefined,
    });

    const patch = markMissing(ids);
    for (const logo of response.data ?? []) {
      patch[logo.id] = { isFetching: false, value: pickImageUrl(logo) };
    }
    return patch;
  } catch {
    return markMissing(ids);
  }
};
